var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-bottom-button",class:{
      'form-bottom-label': _vm.labelSlot,
      'transparent': _vm.transparent
    }},[_c('div',{staticClass:"form-bottom-button__inner"},[_c('div',{staticClass:"label"},[_vm._t("label")],2),_c('mt-button',{class:{ 'radius': _vm.facadeArr.indexOf('radius') >= 0 },attrs:{"type":_vm.type,"size":_vm.size},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.text || '保存'))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }